import { useMemo } from 'react';
import { computeTimeline } from '@/lib/timeline';
import type { ProjectTimeline, ReelProject } from '@/types';

export function useProjectTimeline(project: ReelProject | undefined): ProjectTimeline {
  return useMemo(() => {
    if (!project) return { totalDurationSeconds: 0, items: [] };
    return computeTimeline(project);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project && JSON.stringify(project)]);
}
